export default "__VITE_ASSET__Czlb3X2k__"